module.exports = __webpack_public_path__ + "img/options-2.828bbef8.png";